import type { ComponentProps } from "solid-js";
import EventAnalytics from "~/js/utilities/EventAnalytics";
import { routerConfig } from "~/solidJs/app/MainApp/models";
import { constructLinkWithParams } from "../../helpers/urlHelpres";

export const constructTeamInvitationLink = ({ token }: { token: string }) => {
	const url = constructLinkWithParams(`${routerConfig.teamInvitationPage.absolute}`, {
		token
	});
	return url.href;
};

export const createTeamInvitationProps = (token: string) => {
	const url = constructTeamInvitationLink({ token });
	return {
		href: url,
		onClick: () => {
			EventAnalytics.accountUiInteracted("open_team_invitation", "invitation_link");
		}
	} as const satisfies ComponentProps<"a">;
};
